import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowRightSm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12.833 7.625 17 12m0 0-4.167 4.375M17 12H7"
    />
  </svg>
);
export default SvgArrowRightSm;
